<template>
  <header class="marketing-automation-header">

    <div class="marketing-automation-header-action">
      <button class="btn btn-round btn-primary"
              @click="showCreateModal">{{$t('message.automation.message.createAutomation')}}</button>
    </div>

    <app-search-bar class="marketing-automation-header-search"
                    v-model="search"
                    @enter="emitAutomationSearch" />

    <marketing-automation-create-name-modal :showing.sync="showingCreateModal"
                                            @created="goToAutomationPage" />
  </header>
</template>

<script>
import MarketingAutomationCreateNameModal from "@components/modules/marketing/automation/create/name/modal/MarketingAutomationCreateNameModal";
import AppSearchBar from "@components/Search";
import EventBus from "@packages/event-bus";

export default {
  components: {
    AppSearchBar,
    MarketingAutomationCreateNameModal,
  },

  props: {},

  data() {
    return {
      search: "",
      showingCreateModal: false,
    };
  },

  methods: {
    emitAutomationSearch() {
      EventBus.$emit("AUTOMATION_SEARCH", this.search);
    },
    showCreateModal() {
      this.showingCreateModal = true;
    },
    goToAutomationPage(automationId) {
      this.$router.push(`/marketing/automacao/${automationId}`);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-header {
  display: flex;
  align-items: center;

  .marketing-automation-header-action {
    flex: 1;
  }

  .marketing-automation-header-search {
    flex: 0;
    min-width: 200px;
    padding-top: 0 !important;
  }
}
</style>
